/* eslint-disable @typescript-eslint/no-unused-vars */
import { call, put, takeLatest } from "redux-saga/effects";
import { ApiResponse, RemovePayload } from "models";
import { PayloadAction } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import accessRoleApi from "api/accessRole";
import { accessRoleActions } from "./accessRoleSlice";
import { AccessRole, AccessRolePayload } from "models/accessRole";

function* getAccessRoleList(action: PayloadAction<AccessRolePayload>) {
  try {
    const response: ApiResponse = yield call(
      accessRoleApi.getAccessRoleList,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      yield put(accessRoleActions.getAccessRoleListSuccess(data));
    }
  } catch (error: any) {
    const errorData = error.response?.data;
    yield put(accessRoleActions.getAccessRoleListFailed(errorData));
  }
}

function* getAccessRoleById(action: PayloadAction<AccessRolePayload>) {
  try {
    const response: ApiResponse = yield call(
      accessRoleApi.getAccessRolebyId,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      yield put(accessRoleActions.getAccessRoleByIdSuccess(data));
    }
  } catch (error: any) {
    const errorData = error.response?.data;
    yield put(accessRoleActions.getAccessRoleByIdFailed(errorData));
  }
}

function* getModuleList(action: PayloadAction<AccessRolePayload>) {
  try {
    const response: ApiResponse = yield call(accessRoleApi.getModuleList);
    const data: ApiResponse = response.data;
    if (data.success) {
      yield put(accessRoleActions.getModuleListSuccess(data));
    }
  } catch (error: any) {
    const errorData = error.response?.data;
    yield put(accessRoleActions.getModuleListFailed(errorData));
  }
}

function* getModuleListById(action: PayloadAction<AccessRolePayload>) {
  try {
    const response: ApiResponse = yield call(
      accessRoleApi.getModuleById,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      yield put(accessRoleActions.getModuleByIdSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    yield put(accessRoleActions.getModuleByIdFailed(errorData));
  }
}

function* addAccessRole(action: PayloadAction<AccessRole>) {
  try {
    const response: ApiResponse = yield call(
      accessRoleApi.addAccessRole,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(accessRoleActions.addAccessRoleSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    toast.error(errorData?.message || "Something went wrong");
    yield put(accessRoleActions.addAccessRoleFailed(errorData));
  }
}

function* updateAccessRole(action: PayloadAction<AccessRole>) {
  try {
    const response: ApiResponse = yield call(
      accessRoleApi.updateAccessRole,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(accessRoleActions.updateAccessRoleSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    toast.error(errorData?.message || "Something went wrong");
    yield put(accessRoleActions.updateAccessRoleFailed(errorData));
  }
}

function* deleteAccessRole(action: PayloadAction<RemovePayload>) {
  try {
    const response: ApiResponse = yield call(
      accessRoleApi.deleteAccessRole,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(accessRoleActions.deleteAccessRoleSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    toast.error(errorData?.message || "Something went wrong");
    yield put(accessRoleActions.deleteAccessRoleFailed(errorData));
  }
}

export default function* accessRoleSaga() {
  yield takeLatest(accessRoleActions.getAccessRoleList.type, getAccessRoleList);
  yield takeLatest(accessRoleActions.getAccessRoleById.type, getAccessRoleById);
  yield takeLatest(accessRoleActions.getModuleList.type, getModuleList);
  yield takeLatest(accessRoleActions.getModuleById.type, getModuleListById);
  yield takeLatest(accessRoleActions.addAccessRole.type, addAccessRole);
  yield takeLatest(accessRoleActions.updateAccessRole.type, updateAccessRole);
  yield takeLatest(accessRoleActions.deleteAccessRole.type, deleteAccessRole);
}
